export function normalizeUmlauts(str: string): string {
    return str
        .replace(/Ü/g, "Ue")
        .replace(/ü/g, "ue")
        .replace(/Ö/g, "Oe")
        .replace(/ö/g, "oe")
        .replace(/Ä/g, "Ae")
        .replace(/ä/g, "ae")
        .replace(/ß/g, "ss")
}
